<template>
<div>
    <div class="projects-filters d-flex aic jcc gap-10" :class="{'has-description':storeFilters.selectedSlug !== 'all'}">
    <FilterItem slug="all" label="Tous les projets"  />
   <FilterItem v-for="cat in categoriesList" :key="cat.id" :id="cat.id" :slug="cat.slug" :label="cat.name" :description="cat.description"/>
</div> 
<div class="filter-description" v-if="storeFilters.selectedDescription">
    {{ storeFilters.selectedDescription }}
</div>
</div>

</template>
<script setup lang='ts'>
/*  IMPORTS  */
import FilterItem from './FilterItem.vue';
/*  VARIABLES  */
const storeCategories = useStoreCategories();
const categories = storeCategories.categories;
const storeFilters = useFiltersStore()

const categoriesList = categories.filter(cat => cat.slug !== "non-classe")


</script>

<style lang="scss">
    .projects-filters{
        @media screen and (max-width:1035px) {
            flex-wrap: wrap;
            justify-content: flex-start;
        }
        &.has-description{
            position: relative;
        }
    }
            .filter-description{
            color: $text;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
            padding-top: 30px;
            max-width: 800px;
            margin: auto;
            &.active{
                opacity: 1;
            }
        }
</style>